/**
 * @title compareproductspage.js: Feature level module
 * @description The module used for the compare products page
 * feature which encapsulates the compare products page.
 * @author reckard
 */
define(['addMemberNumber', 'compareProducts', 'extendedAddToCart', 'linkMembership'], function(addMemberNumber, compareProductsBox, extendedAddToCart, linkMembership) {
	
	var Compare = {
			
		init : function() {
			$('#show-differences').unbind('click').on('click', Compare.showDifferences);
			$('#hide-differences').unbind('click').on('click', Compare.hideDifferences);
			$('#product-tile-box').on('click', '.remove-link', Compare.removeProduct);
			Compare.validateAddToCartForms();
			$('input[name=add-to-cart]').unbind('click').on('click', function() {
				$(this.form).submit();
			});
			$('input[name=more-details').unbind('click').on('click', function() {
				var link = $(this).closest('.product').find('.product-tile-set').attr('data-pdp-url');
				/*link = link.replace("window.location.href=","");
				link=link.replace(/'/g,'');*/
				window.location.href=link;
			});
			$('input[name=continue-shopping]').unbind('click').on('click', Compare.continueShopping);
			Compare.displayFormButtons();
			extendedAddToCart.init();
			COSTCO.util.safe(linkMembership.init, 'LinkMembership.init').call(linkMembership);
		},
		
		/**
		 * Displays the correct form buttons and member pricing using the member cookie.
		 * Add to Cart will not be shown for variants
		 */
		displayFormButtons : function() {
			COSTCO.util.display_member_prices();
			var userInfo = COSTCO.util.getMemberCookie(),
				signedIn = userInfo.signedIn, 
				costcoMember = userInfo.costcoMember != 'undefined' ? userInfo.costcoMember : false,
				validated = userInfo.validated != 'undefined' ? userInfo.validated : false;
			    active = userInfo.active != 'undefined' ? userInfo.active : false;
			// This check is added to keep BD flow unaffected by the change in BC flow
			var showInputForMember = COSTCO.util.isBusinessDelivery() ? costcoMember : costcoMember && validated && active;
			if (!signedIn) {
				$('input[name=sign-in-to-buy]').removeClass('hide');
			}
			else {
				if (showInputForMember) {
					$('input[name=add-to-cart], input[name=more-details]').removeClass('hide');
				}
				else {
					$('.mem-button').removeClass('hide');
				}
			}
		},
		
		/**
		 * For the continue shopping button, instead of using the backURL param, take the user
		 * back to their previous page or to the home page if they came to the compare products
		 * page from somewhere besides costco's website.
		 */
		continueShopping : function() {
			if (document.referrer.indexOf('costco.') > -1) {
				window.location = COSTCO.util.scrubSpecialChars(document.referrer);
			}
			else {
				window.location = '/';
			}
		},
		
		/**
		 * Highlights rows where there are differences in product attributes
		 */
		showDifferences : function() {
			$('#compare-products-table .compare-values').each(function() {
				var values = $('td', this).map(function() {
					return $(this).text() == "" ? null : $(this).text().trim().toLowerCase();
				});
				if (COSTCO.util.unique(values).length != 1) {
					$(this).addClass('has-difference');
				}
			});
			
			$('.has-difference th').append("<span class='sr-only hasSR'>" + messages.HAS_DIFFERENCES + "</span>");
			$('.compare-values-header').addClass('has-difference');
			$('#show-differences').hide();
			$('#hide-differences').show();
		},
		
		/**
		 * Removes highlighting of product attribute differences
		 */
		hideDifferences : function() {
			$('.has-difference th span').remove();
			$('#compare-products-table .has-difference').removeClass('has-difference');
			$('#hide-differences').hide();
			$('#show-differences').show();
		},
		
		/**
		 * Modified version of addToCart function on product page.
		 * Does Ajax call to add minimum quantity to cart and shows modal popup on success
		 * @param  {form} form - the html form to submit
		 * @param {function} done - the function to run after Ajax success
		 * @param {function} fail - the function to run if Ajax fails
		 * @param {function} always - the function to always run after Ajax call
		 */
		ajaxAddToCart : function(form, done, fail, always) {
			var $form = $(form),
				$productDiv = $(form).closest('.product');
				errorDiv = $('.product-error', $form).empty(),
                locale = COSTCO.util.getLocale(),
                quantity = $('input[name=minQty]', $form).val(),
                final_price = (locale=='en-US'||locale=='en-CA'?' $':'')
                    +COSTCO.util.decode($('input[name=price]', $form).val())+(locale=='fr-CA'?' $':''),
                formData = $form.serializeArray(),
                cleanData = {'ajaxFlag': true},
                selected_products = [];
            $.each(formData, function(index, value){
                var dataName = formData[index].name;
                var dataValue = formData[index].value;
                if(dataName == 'relatedQty'){ dataName = 'quantity'; }
                if (!/_\d$/.test(dataName) && dataValue !== '' && dataValue !== '0') {
                    cleanData[dataName] = dataValue;
                }
            });
            var productIndex = 1;
            cleanData['catalogEntryId_'+productIndex] = cleanData['catEntryId'];
            if(cleanData['quantity'] == undefined){
                cleanData['quantity'] = $('#minQtyText').val();
            }
            cleanData['quantity_'+productIndex] = cleanData['quantity'];
            var selected_product = {}; //object used to display information in modal popup as part of done function
            selected_product.quantity = $('input[name=quantityString]', $(form)).val();;
            selected_product.item_number = $('input[name=itemNumberString]', $(form)).val();
            selected_product.final_price = final_price;
            selected_product.productName = $('.description', $productDiv).text();
            selected_product.productUrl = $('.thumbnail', $productDiv).attr('href');
            selected_product.img_url = $('img', $productDiv).attr('src');
            selected_product.isFsaChdItem = $('input[name=isFsaChdItem]', $(form)).val();
            selected_products = selected_products.concat(selected_product);
            
            
			$.ajax({
                url: $(form).attr('action'),
                type: $(form).attr('method'),
                data: cleanData,
                dataType: 'json'
            }).done(function(data, textStatus, xhr, errorDiv){
                data.selected_products = selected_products;
                data.form_id = $form.attr('id');
                if(typeof errorDiv === 'undefined' ){
                	errorDiv = $('.product-error', $form).empty();
                }
                if (done) done(data, textStatus, xhr, errorDiv);
            }).fail(function(xhr, textStatus, errorThrown){
                if (fail) fail(xhr, textStatus, errorThrown)
            }).always(function(data, textStatus, errorThrown) {
                if (always) always(data, textStatus, errorThrown);
            });
		},
		
		/**
		 * Modified validation from product page.
		 * Validates and sets up the addToCart forms and data.
		 */
		validateAddToCartForms : function() {
			
			function form_done(data, textStatus, xhr, errorDiv) {
				if (has_error(data, errorDiv) == 0) {
					 if (data.redirecturl != null) {
	                    urlWithoutQueryString = data.redirecturl.split('?')[0];
	                    var appType = $('#applicationType').val();
	                    if (urlWithoutQueryString.indexOf('CatalogSearch') != -1 
	                        || (urlWithoutQueryString.indexOf('.html') != -1 
	                            && urlWithoutQueryString.indexOf('.product.') == -1)
	                            || (appType !== undefined && appType === 'BC' && (urlWithoutQueryString.indexOf('QuickMembershipApplicationView') !== -1
	                            		|| urlWithoutQueryString.indexOf('MembershipApplicationView') !== -1))) {
	                        var url = data.redirecturl;
	                        delete data.redirecturl; 
	                        delete data.selected_products;
	                        var params = $.param(data);
	                        var decodedUrl = $("<div/>").html(url).text();
	                        var finalUrl;
	                        if (decodedUrl.indexOf('?') != -1) {
	                            if (decodedUrl.substr(decodedUrl.length - 1) == '&') {
	                                finalUrl = decodedUrl + params;
	                            } else {
	                                finalUrl = decodedUrl + '&' + params;
	                            }
	                        } else {
	                            finalUrl = decodedUrl + '?' + params;
	                        }
	                        document.location.href = finalUrl; 
	                        return;
	                    }
					}
					 Compare.added_modal(data.selected_products);
				}
				
				$('input[type=button]').removeAttr('disabled');
			}
			
			function form_fail() {
				$('input[type=button]').removeAttr('disabled');
			}
			
			function form_always() {
				$('input[type=button]').removeAttr('disabled');
				COSTCO.Header.miniShopCartRefresh();
			}
			
			function has_error(data, errorDiv) {
	            var errorCount = 0;
	            if (data.errorCode) {
	                if (data.errorCode == 2510) { // session timeout
	                    document.location.href = 'Logoff?URL=ReLogonFormView';
	                    return;
	                }
	            } else {
	                if (data.orderErrMsgObj){
	                    var errors = data.orderErrMsgObj;
	                    for (var errorKey in errors) {
	                        if (errors.hasOwnProperty(errorKey)) {
	                            errorCount++;
	                            errorDiv.append('<p class="error">' + errors[errorKey].replace('~',',').replace("''","'").replace(/&lt;/g, '<').replace(/&gt;/g, '>') + "</p>")
	                        }
	                    }
	                }
	            }
	            return errorCount;
			}
			
			$('.add-to-cart-form').each(function(index, form) {
				$(form).validate({
	                submitHandler: function() {
						$('input[type=button]').attr('disabled', 'disabled');
						Compare.ajaxAddToCart(form, form_done, form_fail, form_always);
	                }.bind(this)
	            }).form();
			});
		},
		
		/**
		 * Removes product from compare page and light box
		 */
		removeProduct : function() {
			compareProductsBox.removeItem($(this).closest('.product').find('input[name=itemPartNumber]').val());
			var index = $(this).closest('.product').index() + 1;
			$('#product-tile-box .product').filter(':nth-child('+ index + ')').text('');
			$('#compare-products-table td').filter(':nth-child(' + (index + 1) + ')').text('');
			$('#compare-products-table th').filter(':nth-child(' + (index + 1) + ')').text('');
			Compare.hideDifferences();
			if ($('.remove-link').length == 0) {
				$('#compare-active').addClass('hide');
				$('#compare-all-removed').removeClass('hide');
			}
		},
		
		/**
         * Add to cart modal. Invoked after the "done" promise resolves
         * when calling ajaxAddToCart. Taken from product page
         * @param  {[array]} selected_products Array of objects representing
         * the items that went into the cart
         */
        added_modal : function(selected_products) {
        	$('.modal-footer').addClass('hide');
        	var items_html;
        	selected_products.forEach(function(product) {
        		items_html = COSTCO.util.tmpl(product.isFsaChdItem == 'true' ? 'tmpl_addtocart_item_FsaChd':'tmpl_addtocart_item', {
        			img_url : product.img_url ? product.img_url : product.parent_img_url,
        			item_name : product.productName,
        			item_url : product.productUrl,
                    item_number : product.item_number,
                    model_number: product.manufacturerPartNumber,
                    price : product.final_price,
        			quantity : product.quantity,
        			linkFee: "",
        			parts_and_services_html :""
        		})
        	});
        	COSTCO.dialog.createExtDialogBox({
                title : messages.RELATED_PRODUCT_ADDED_TO_CART,
                body : COSTCO.util.tmpl('tmpl_addtocart_modal',{
                	items : items_html,
                	related_products : ''
                }),
                onclose : function() {
                	$('.modal-footer').removeClass('hide');
                }
            });
        },
	}
		
	if (typeof window.COSTCO == 'undefined') {
			window.COSTCO = new Object();
	}
	
	if (typeof window.COSTCO.Global == 'undefined') {
		document.addEventListener("CostcoGlobalLoaded", Compare.init, false);
	}
	else {
		Compare.init();
	}

	window.COSTCO.Compare = Compare;
	
});


// WEBPACK FOOTER //
// ./js/compare/compareproductspage.js